import styled, { css } from 'styled-components';

import star from '~/assets/icons/star.svg';
import expStar from '~/assets/icons/star_exp.svg';
import { Text } from '~/components/ui/Text';

import { Popup } from '../Popup';

const StyledBackground = styled.div<{ $progress: number }>`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	width: ${(props) => props.$progress}%;
	height: 100%;
	border-radius: ${(props) =>
		props.$progress === 100 ? '10px' : '10px 0 0 10px'};
	background-color: rgba(250, 190, 44, 0.5);
`;

const StyledTopContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	justify-content: space-between;
	transition: opacity 0.3s ease;
`;

const StyledStar = styled.img.attrs({ src: star })<{ $pinned: boolean }>`
	transition: opacity 0.3s ease;
	user-select: none;

	${(props) =>
		props.$pinned
			? css`
					opacity: 1;
			  `
			: css`
					opacity: 0.5;

					&:hover {
						opacity: 1;
					}
			  `}
`;

const StyledBottomContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: opacity 0.3s ease;
`;

const StyledRewardsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	font-size: 16px;
	font-weight: 700;
`;

const StyledRewardContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	user-select: none;
	pointer-events: none;

	${Text} {
		font-size: 16px;
		font-weight: 700;
	}
`;

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 50%;
`;

const StyledPopup = styled(Popup)`
	position: absolute;
	top: -50px;
	transform: translateX(-55px);
`;

const StyledXPStar = styled.div`
	width: 14px;
	height: 14px;
	mask-image: url(${expStar});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${expStar});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffb500;
`;

const StyledTaskText = styled(Text)`
	font-size: 16px;
	color: #ffffff;
	opacity: 0.5;
	height: 46px;
	z-index: 2;
	transition: opacity 0.3s ease;
`;

const StyledContainer = styled.div<{ $complete: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
	height: 160px;
	padding: 20px 20px 18px 20px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	${({ $complete }) =>
		$complete &&
		css`
			${StyledTopContainer}, ${StyledBottomContainer}, ${StyledTaskText} {
				opacity: 0.1;
			}
		`}
`;

const StyledComplete = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 7px 10px;
	gap: 10px;
	background: #fabe2c;
	box-shadow: 0px 0px 24px rgba(250, 190, 44, 0.3);
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		filter: invert(1);
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #000000;
		white-space: nowrap;
	}
`;

export {
	StyledBackground,
	StyledBottomContainer,
	StyledComplete,
	StyledContainer,
	StyledDot,
	StyledPopup,
	StyledRewardContainer,
	StyledRewardsContainer,
	StyledStar,
	StyledTaskText,
	StyledTopContainer,
	StyledXPStar,
};
